import uaNum from './uaJudgment.js';
// import ScrollMagic from 'scrollmagic';

/**
 * サンプルクラス
 * @constructor
 */
 class Inview {

  constructor() {
    this._addClassNameval = 'is-inView';
    this._uaNum = uaNum;
    this._borderNum = 0;
    this.init();
  }
  /**
 * サンプル
 */
  init() {
    // TOPページのKV下の最新情報エリアの制御
    if (document.querySelector('.js-recuite_top_movie')) {
      // movieエリアのスクロール連動の拡大
      this.recuiteTopMovie('.js-recuite_top_movie');
      // movie自体の再生の挙動
      this.movie_func('loopingVideo');
    }
  }

  recuiteTopMovie() {
    const initialScale = 0.94; // 初期スケール (94%)
    const maxScale = 1.0; // 最大スケール (100%)
    let scale = initialScale; // 初期スケールを設定
    let divisonNum;

    if (this._uaNum === 1) { // SPだった場合
      divisonNum = 1500;
    } else { // pcだった場合
      divisonNum = 3000;
    }

    const targetMovie = document.querySelector('.js-recuite_top_movie');

    let lastScrollPosition = window.scrollY;
    const handleScroll2 = () => {
      const currentScrollPosition = window.scrollY;

      if (currentScrollPosition > lastScrollPosition) {
        scale = Math.min(initialScale+(window.scrollY/divisonNum/1.6), maxScale);
        targetMovie.style.transform = `scale(${scale})`;
      } else if (currentScrollPosition < lastScrollPosition) {
        scale = Math.min(initialScale+(window.scrollY/divisonNum/1.6), maxScale);
        targetMovie.style.transform = `scale(${scale})`;
      }

      lastScrollPosition = currentScrollPosition;
    };

    window.addEventListener('scroll', handleScroll2);
  }

  //movie自体のコントロール（特定の秒数に戻るループ再生）
  movie_func(movieElem) {
    const video = document.getElementById(movieElem);
    const sourceElement = video.querySelector('source');
    const pcVideoSrc = '/assets/movie/recruite_movie.mp4';
    const spVideoSrc = '/assets/movie/recruite_movie--sp.mp4';
    const loopStartTime = 5.2; // 指定の秒数

    if (this._uaNum === 1) {
      // SPだった場合
      sourceElement.src = spVideoSrc;
      video.load();
    } else {
      // pcだった場合
      sourceElement.src = pcVideoSrc;
      video.load();
    }

    // 動画再生が終了したときのイベント
    video.addEventListener('ended', () => {
      // 指定の秒数に戻る
      video.currentTime = loopStartTime;
      video.play(); // 動画を再生
    });

    // 動画が再生されたときのイベント
    video.addEventListener('play', () => {
      // 指定の秒数以降の再生を監視
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= video.duration) {
          // 動画の最後に達したら、指定の秒数に戻る
          video.currentTime = loopStartTime;
        }
      });
    });
  }
}

export default Inview;
